module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/mariya_c84396.png";